import { render, staticRenderFns } from "./PageFast.vue?vue&type=template&id=8841ccfa&scoped=true"
import script from "./PageFast.vue?vue&type=script&lang=js"
export * from "./PageFast.vue?vue&type=script&lang=js"
import style0 from "./PageFast.vue?vue&type=style&index=0&id=8841ccfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8841ccfa",
  null
  
)

export default component.exports